import React, { useState, useEffect } from 'react';
import { getBeneficiaries, homeStore } from '../services/authService';
import { showSuccess, showError } from '../utils/alert';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const HomeVisitAdd = () => {
         const [beneficiary, setBeneficiary] = useState(null); // initially null
         const [beneficiaryList, setBeneficiaryList] = useState([]);
         const [showUserForm, setShowUserForm] = useState(false);
         const navigate = useNavigate();
     const selectedVillageId = useSelector((state) => state.village.selectedVillageId);
     const goBack = () => navigate("/home-visits");


    
         useEffect(() => {
            async function fetchBeneficiaries() {
              try {
                const getBen = await getBeneficiaries();
        
                // Check if the API call was successful
                if (getBen.status === true) {
                  // Show success alert
                  showSuccess(getBen.message || 'Beneficiaries fetched successfully!');
        
                  // Format the beneficiary data
                  const formattedList = getBen.data.map(b => ({
                    id: b.beneficiary_id,
                    name: b.name,
                    age: b.age, // Age is already provided in the response
                    gender: b.gender,
                    condition: b.category,
                    village: b.village_name || 'Unknown', // Fallback for village_name
                  }));
        
                  // Update state with formatted list
                  setBeneficiaryList(formattedList);
        
                  // Automatically set the first beneficiary as default
                  if (formattedList.length > 0) {
                    setBeneficiary(formattedList[0]);
                  }
                } else {
                  // Show error alert for API status: false
                  showError(getBen.message || 'No beneficiaries found');
                 
                }
              } catch (err) {
                // Show error alert for network or unexpected errors
                showError('Network error or something went wrong');
               
              }
            }
        
            fetchBeneficiaries();
          }, [selectedVillageId]);  


    const [formData, setFormData] = useState({
        visitDate: '',
        purpose: '',
        healthStatus: '',
        actionsTaken: [],
        followUp: false,
        followUpDate: '',
        notes: '',
    });

    const handleActionToggle = (action) => {
        setFormData((prev) => ({
            ...prev,
            actionsTaken: prev.actionsTaken.includes(action)
                ? prev.actionsTaken.filter(a => a !== action)
                : [...prev.actionsTaken, action]
        }));
    };

    const handleSave = async () => {
        const payload = {
            beneficiary_id: beneficiary.id,  
            visit_datetime: formData.visitDate + 'T09:00:00Z', // ISO 8601 format
            visit_purpose: formData.purpose,
            health_status: formData.healthStatus,
            actions_taken: JSON.stringify(formData.actionsTaken),
            follow_up_needed: formData.followUp,
            next_visit_date: formData.followUpDate || null,
            notes: formData.notes
        };
       
        try {
            const response = await homeStore(payload);
       
            if (response.status === true) {
                showSuccess(response.message);  

                navigate('/home-visits'); 
            }
        } catch (error) {
            showError('Network error or something went wrong');  
        }
    };
      
    return (
        <>
            <div className="page-header">
       
                <button className="back-button" onClick={goBack}>
                    <i className="fas fa-arrow-left"></i>
                    Back
                </button>
                <div className="page-title">New Home Visit</div>
            </div>

            <div className="form-card">
                  {/* Beneficiary Section */}
                   {/* Beneficiary Selection */}
                   {beneficiary && (
    <div className="form-section">
        <div className="section-title">Select Beneficiary</div>
        <div className="beneficiary-card">
            <div className="beneficiary-info">
                <div className="beneficiary-name">{beneficiary.name}</div>
                <div className="beneficiary-details">
                    {beneficiary.age} years • {beneficiary.gender} • {beneficiary.condition}
                </div>
                <div className="beneficiary-village">{beneficiary.village}</div>
            </div>
            <button className="change-button" onClick={() => setShowUserForm(!showUserForm)}>
                Change
            </button>
        </div>

        {showUserForm && (
            <div className="form-section">
                <label>Select a Beneficiary</label>
                <select
                    onChange={(e) => {
                        const selected = beneficiaryList.find(b => b.name === e.target.value);
                        if (selected) {
                            setBeneficiary(selected);
                            setShowUserForm(false);
                        }
                    }}
                    defaultValue=""
                >
                    <option value="" disabled>Select beneficiary...</option>
                    {beneficiaryList.map((b) => (
                        <option key={b.id} value={b.name}>
                            {b.name} - {b.age} yrs - {b.village}
                        </option>
                    ))}
                </select>
            </div>
        )}
    </div>
)}


                <hr className="divider" />

                {/* Visit Date */}
                <div className="form-section">
                    <div className="section-title">Visit Date</div>
                    <input
                        type="date"
                        className="date-picker"
                        value={formData.visitDate}
                        onChange={(e) => setFormData({ ...formData, visitDate: e.target.value })}
                    />
                </div>

                <hr className="divider" />

                {/* Visit Purpose */}
                <div className="form-section">
                    <div className="section-title">Visit Purpose</div>
                    <div className="radio-group">
                        {['Routine', 'Follow-up', 'Emergency','followup'].map(p => (
                            <div className="radio-option" key={p}>
                                <input
                                    type="radio"
                                    id={p}
                                    name="purpose"
                                    value={p}
                                    checked={formData.purpose === p}
                                    onChange={(e) => setFormData({ ...formData, purpose: e.target.value })}
                                />
                                <label htmlFor={p}>{p.charAt(0).toUpperCase() + p.slice(1)}</label>
                            </div>
                        ))}
                    </div>
                </div>

                <hr className="divider" />

                {/* Health Status */}
                <div className="form-section">
                    <div className="section-title">Health Status</div>
                    <div className="radio-group">
                        {['healthy', 'minor', 'attention', 'critical'].map(status => (
                            <div className="radio-option" key={status}>
                                <input
                                    type="radio"
                                    id={status}
                                    name="healthStatus"
                                    value={status}
                                    checked={formData.healthStatus === status}
                                    onChange={(e) => setFormData({ ...formData, healthStatus: e.target.value })}
                                />
                                <label htmlFor={status}>{status.charAt(0).toUpperCase() + status.slice(1)}</label>
                            </div>
                        ))}
                    </div>
                </div>

                <hr className="divider" />

                {/* Actions Taken */}
                <div className="form-section">
                    <div className="section-title">Actions Taken</div>
                    <div className="section-subtitle">Select all that apply</div>
                    <div className="chip-container">
                        {['Counseling', 'Medication', 'Vitals Check', 'Nutrition Advice', 'Sanitation Education'].map(action => (
                            <div
                                className={`chip ${formData.actionsTaken.includes(action) ? 'selected' : ''}`}
                                key={action}
                                onClick={() => handleActionToggle(action)}
                            >
                                {action}
                            </div>
                        ))}
                    </div>
                    <textarea
                        className="text-area"
                        placeholder="Describe other actions taken..."
                        value=""
                        
                    />
                </div>

                <hr className="divider" />

                {/* Follow-up */}
                <div className="form-section">
                    <div className="section-title">Follow-up</div>
                    <div className="checkbox-option">
                        <input
                            type="checkbox"
                            id="followup-needed"
                            checked={formData.followUp}
                            onChange={(e) => setFormData({ ...formData, followUp: e.target.checked })}
                        />
                        <label htmlFor="followup-needed">Follow-up needed</label>
                    </div>
                    <input
                        type="date"
                        className="date-picker"
                        value={formData.followUpDate}
                        onChange={(e) => setFormData({ ...formData, followUpDate: e.target.value })}
                    />
                </div>

                <hr className="divider" />

                {/* Notes */}
                <div className="form-section">
                    <div className="section-title">Notes</div>
                    <textarea
                        className="text-area"
                        placeholder="Additional notes..."
                        value={formData.notes}
                        onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                    />
                </div>

                {/* Action Buttons */}
                <div className="action-buttons">
                    <button className="cancel-button"  onClick={goBack}>
                        Cancel
                    </button>
                    <button className="save-button" onClick={handleSave}>
                        <i className="fas fa-save"></i> Save
                    </button>
                </div>
            </div>
        </>
    );
};

export default HomeVisitAdd;
